<template>
    <div class="product-sharing-manage">
        <div id="main-container" :class="{ 'slide-left': isSlideLeft }" class="container">
            <div id="records-page" class="records-page">
                <div class="page-header">
                    <div class="page-title">
                        <h1>商品分享记录</h1>
                        <p>查看历史分享记录或创建新的分享</p>
                    </div>
                    <button id="new-share-btn" class="new-share-btn" @click="openNewShare">
                        <i class="fas fa-plus"></i>
                        <span>新增分享</span>
                    </button>
                </div>
                <div class="records-container">
                    <div id="records-list" class="records-list">
                        <div v-if="recordsTotal > 0" class="records-section-title">
                            <span>历史分享记录</span>
                            <span id="record-count" class="record-count">{{ recordsTotal }}条记录</span>
                        </div>
                        <div v-if="recordsTotal === 0" id="empty-records" class="empty-records">
                            <div class="empty-icon">
                                <i class="far fa-clipboard"></i>
                            </div>
                            <h3 class="empty-title">暂无分享记录</h3>
                            <p class="empty-desc">您还没有分享过商品，点击右上角"新增分享"按钮开始分享</p>
                            <button id="empty-new-share-btn" class="empty-btn" @click="openNewShare">
                                <i class="fas fa-plus"></i>
                                <span>新增分享</span>
                            </button>
                        </div>

                        <div
                            v-for="record in sortedRecords"
                            :key="record.id"
                            :data-id="record.id"
                            class="record-item"
                            @click="openRecord(record.id)"
                        >
                            <div class="record-header">
                                <div class="record-time">{{ record.time }}</div>
                                <div :class="recordStatusClass(record)" class="record-status">
                                    {{ recordStatusText(record) }}
                                </div>
                            </div>
                            <div class="record-product">
                                <div class="product-icon">{{ record.productIcon }}</div>
                                <span>{{ record.product }}</span>
                            </div>
                            <div class="record-users">
                                <div class="user-avatars">
                                    <template v-for="u in record.users.slice(0, 4)">
                                        <div :key="u.id" class="user-avatar">{{ u.avatar }}</div>
                                    </template>
                                    <div
                                        v-if="record.users.length > 4"
                                        class="user-avatar"
                                        style="background-color: #2575fc; color: white"
                                    >
                                        +{{ record.users.length - 4 }}
                                    </div>
                                    <div class="user-count">{{ record.users.length }}位客户</div>
                                </div>
                                <div class="viewed-count">已查看：<strong>{{ recordViewedText(record) }}</strong></div>
                            </div>
                        </div>
                    </div>

                    <div class="records-pagination">
                        <Pagination
                            :currentPage="recordsPage"
                            :pageSizes="recordsPageSizes"
                            :parentPageSize="recordsPageSize"
                            :totalNumber="recordsTotal"
                            @loadTable="handleRecordsLoadTable"
                        />
                    </div>
                </div>
            </div>

            <div id="share-page" class="share-page">
                <div class="share-header">
                    <button id="back-button" class="back-button" @click="showRecordsPage">
                        <i class="fas fa-arrow-left"></i>
                    </button>
                    <h1 id="share-page-title">{{ sharePageTitle }}</h1>
                </div>

                <div id="share-content" class="share-content">
                    <div v-show="shareView === 'detail'" id="share-detail-view" class="share-detail-view">
                        <div class="share-info-card">
                            <div class="share-meta">
                                <div id="detail-share-time" class="share-time">{{
                                        activeRecord ? activeRecord.time : ""
                                    }}
                                </div>
                                <div
                                    id="detail-share-status"
                                    :class="activeRecord ? recordStatusClass(activeRecord) : ''"
                                    class="record-status"
                                >
                                    {{ activeRecord ? recordStatusText(activeRecord) : "" }}
                                </div>
                            </div>

                            <div class="product-header">
                                <div class="product-image">{{
                                        activeRecord ? activeRecord.productIcon : productIconText
                                    }}
                                </div>
                                <div class="product-info">
                                    <h3>{{ activeRecord ? activeRecord.product : productTitle }}</h3>
                                    <div class="product-price">
                                        {{productPriceText}}
<!--                                        {{ activeRecord ? activeRecord.priceText : productPriceText }}-->
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="shared-users-section">
                            <div class="section-title">
                                <span>已分享客户</span>
                                <span id="shared-users-count" class="record-count">{{
                                        activeRecordUserCountText
                                    }}</span>
                            </div>
                            <div id="shared-users-list">
                                <div v-for="u in activeRecordUsers" :key="u.id" class="shared-user-item">
                                    <div class="user-info">
                                        <div class="user-avatar-medium">{{ u.avatar }}</div>
                                        <div class="user-details">
                                            <h4>{{ u.name }}</h4>
                                            <p>ID: {{ u.id }}</p>
                                        </div>
                                    </div>
                                    <div :class="u.viewed ? 'viewed' : 'not-viewed'" class="user-status">
                                        {{ u.viewed ? "已查看" : "未查看" }}
                                    </div>
                                </div>
                            </div>

                            <div class="action-buttons">
                                <button
                                    id="reshare-button"
                                    :disabled="!activeRecord"
                                    class="action-btn reshare-btn"
                                    @click="openReshare"
                                >
                                    <i class="fas fa-share-alt"></i>
                                    <span>再次分享</span>
                                </button>
<!--                                <button id="copy-link-btn" class="action-btn copy-btn" @click="copyShareLink">-->
<!--                                    <i class="fas fa-link"></i>-->
<!--                                    <span>复制链接</span>-->
<!--                                </button>-->
                            </div>
                        </div>
                    </div>

                    <div v-show="shareView === 'edit'" id="share-edit-view" class="share-edit-view">
                        <div class="share-info-card">
                            <div class="product-header">
                                <div class="product-image">{{ productIconText }}</div>
                                <div class="product-info">
                                    <h3>{{ productTitle }}</h3>
                                    <div class="product-price">{{ productPriceText }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="share-options">
                            <div
                                id="share-to-client"
                                :class="{ active: shareMode === 'client' }"
                                class="share-option"
                                @click="shareMode = 'client'"
                            >
                                <div class="option-icon">
                                    <i class="fas fa-user-friends"></i>
                                </div>
                                <div class="option-title">分享给客户</div>
                                <div class="option-desc">从客户列表中选择</div>
                            </div>
                            <div
                                id="share-qr"
                                :class="{ active: shareMode === 'qr' }"
                                class="share-option"
                                @click="shareMode = 'qr'"
                            >
                                <div class="option-icon">
                                    <i class="fas fa-qrcode"></i>
                                </div>
                                <div class="option-title">二维码分享</div>
                                <div class="option-desc">生成商品二维码</div>
                            </div>
                        </div>

                        <div
                            v-show="shareMode === 'client'"
                            id="client-selection"
                            class="client-selection"
                        >
                            <div class="search-box">
                                <i class="fas fa-search search-icon"></i>
                                <input
                                    id="client-search"
                                    v-model.trim="searchTerm"
                                    placeholder="搜索客户姓名、邮箱或电话..."
                                    type="text"
                                />
                            </div>
                            <div class="selected-count">已选择：<strong id="selected-count">{{ selectedCount }}</strong>个客户
                            </div>
                            <div id="client-list" class="client-list">
                                <div
                                    v-for="client in filteredClients"
                                    :key="client.userCid || client.id"
                                    :class="{ selected: isClientSelected(client) }"
                                    :data-id="client.userCid || client.id"
                                    class="client-item"
                                    @click="toggleClient(client)"
                                >
                                    <div class="client-avatar-small">
                                        <img
                                            v-if="normalizeImageUrl(client.userCImageUrl)"
                                            :src="normalizeImageUrl(client.userCImageUrl)"
                                            class="avatar-img"
                                        />
                                        <span v-else class="avatar-text">{{
                                                (client.userCName || client.name || "").slice(0, 1)
                                            }}</span>
                                    </div>
                                    <div class="client-details">
                                        <div class="client-name">{{ client.userCName || client.name || "" }}</div>
                                        <div class="client-contact">
                                            {{
                                                client.userCEmail || client.email || (client.phoneNumber || client.phone || "")
                                            }}
                                        </div>
                                    </div>
                                    <div class="selection-indicator">
                                        <i v-show="isClientSelected(client)" class="fas fa-check-circle"></i>
                                        <i v-show="!isClientSelected(client)" class="far fa-circle"></i>
                                    </div>
                                </div>
                            </div>

                            <div class="pagination-wrap">
                                <Pagination
                                    :currentPage="page"
                                    :pageSizes="pageSizes"
                                    :parentPageSize="pageSize"
                                    :totalNumber="total"
                                    @loadTable="handleClientLoadTable"
                                />
                            </div>

                            <button
                                id="share-button"
                                :disabled="selectedCount === 0 || sendLoading"
                                class="share-action-btn"
                                @click="handleShare"
                            >
                                {{ sendLoading ? "分享中..." : "立即分享" }}
                            </button>
                        </div>

                        <div
                            id="qr-container"
                            :style="{ display: shareMode === 'qr' ? 'flex' : 'none' }"
                            class="qr-container"
                        >
                            <div class="qr-code">
                                <img v-if="qrCodeUrl" :src="qrCodeUrl" class="qr-img"/>
                                <div v-else>二维码预览区域</div>
                            </div>
                            <p class="qr-desc">客户扫描二维码即可查看商品详情并直接购买</p>
                            <button class="share-action-btn" @click="generateQRBtn">下载二维码</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Pagination from "@/components/Pagination.vue";
import Api from "@/components/Api/index.js";

export default {
    name: "ProductSharing",
    components: {Pagination},
    data() {
        return {
            sendLoading: false,
            isSlideLeft: false,
            shareView: "edit",
            shareMode: "client",
            searchTerm: "",
            product: JSON.parse(sessionStorage.getItem("sharingBudget")),
            shareLink: "https://example.com/product/12345",
            qrCodeUrl: "",
            tableData: [],
            total: 0,
            page: 1,
            pageSize: 10,
            pageSizes: [10, 20, 40, 60],
            selectedIds: [],
            selectedClientMap: {},
            shareRecords: [],
            selectedRecordId: null,
            recordsTotal: 0,
            recordsPage: 1,
            recordsPageSize: 10,
            recordsPageSizes: [10, 20, 40, 60]
        };
    },
    computed: {
        productTitle() {
            const p = this.product || {};
            return p.resourceNameCn || p.resourceNameEn || "商品";
        },
        productPriceText() {
            const p = this.product || {};
            if (p.currency && (p.totalPrice || p.totalPrice === 0)) return `${p.currency}${p.totalPrice}`;
            if (p.totalPrice || p.totalPrice === 0) return `￥${p.totalPrice}`;
            return "￥0";
        },
        productIconText() {
            const title = this.productTitle || "";
            return title.slice(0, 1) || "商";
        },
        sharePageTitle() {
            if (this.shareView === "detail") return "分享详情";
            if (this.isReshareMode) return "再次分享";
            return "新增分享";
        },
        isReshareMode() {
            return this.shareView === "edit" && this.selectedRecordId !== null;
        },
        filteredClients() {
            const term = (this.searchTerm || "").toLowerCase();
            if (!term) return this.tableData;
            return this.tableData.filter((c) => {
                const name = String(c.userCName || c.name || "").toLowerCase();
                const email = String(c.userCEmail || c.email || "").toLowerCase();
                const phone = String(c.phoneNumber || c.phone || "");
                return name.includes(term) || email.includes(term) || phone.includes(term);
            });
        },
        selectedCount() {
            return this.selectedIds.length;
        },
        sortedRecords() {
            return [...this.shareRecords].sort((a, b) => (b.sortTime || 0) - (a.sortTime || 0));
        },
        activeRecord() {
            if (this.selectedRecordId === null) return null;
            return this.shareRecords.find((r) => r.id === this.selectedRecordId) || null;
        },
        activeRecordUsers() {
            return this.activeRecord ? this.activeRecord.users : [];
        },
        activeRecordUserCountText() {
            const count = this.activeRecord ? this.activeRecord.users.length : 0;
            return `${count}位客户`;
        }
    },
    beforeDestroy() {
        sessionStorage.removeItem("sharingBudget");
    },
    mounted() {
        this.getSharingRecords();
        this.getCustomerList();
        this.showRecordsPage();
    },
    methods: {
        //获取分享记录
        getSharingRecords() {
            const req = {
                page: this.recordsPage,
                size: this.recordsPageSize,
                q: {
                    budgetMainId: this.$store.state.budgetMainId
                }
            };
            return new Api()
                .shareRecords(req)
                .then((res) => {
                    if (res.status === 200) {
                        let records = res.data.records;
                        this.recordsTotal = Number(res.data.total);
                        this.shareRecords = records.map((r) => this.normalizeShareRecord(r));
                        if (this.selectedRecordId !== null && !this.shareRecords.some((x) => x.id === this.selectedRecordId)) {
                            this.selectedRecordId = null;
                        }
                    } else {
                        this.$message({type: "error", message: res.statusText});
                    }
                }).catch(() => {
                this.$message({type: "error", message: "加载分享记录失败!"});
            });
        },
        handleRecordsLoadTable(page, size) {
            this.recordsPage = page;
            this.recordsPageSize = size;
            this.getSharingRecords();
        },
        normalizeShareRecord(record) {
            console.log(JSON.parse(record.linkData) ,'ksakdkaskaskd')
            const linkData = this.normalizeLinkData(record.linkData);
            const users = this.extractUsersFromLinkData(record.budgetUsers);
            const product = record.resourceName || record.resourceNameCn || record.product || "";
            const productIcon = String(product || "").slice(0, 1) || "商";
            const priceText = this.extractPriceTextFromLinkData(linkData);
            const sortTime = Number(record.createTime || 0);

            return {
                id: record.id,
                time: this.formatTime(record.createTime),
                product,
                productIcon,
                priceText,
                sortTime,
                users,
                raw: {...record, linkData}
            };
        },
        normalizeLinkData(linkData) {
            if (!linkData) return [];
            if (Array.isArray(linkData)) return linkData;
            if (typeof linkData === "string") {
                try {
                    const parsed = JSON.parse(linkData);
                    return Array.isArray(parsed) ? parsed : [];
                } catch (e) {
                    return [];
                }
            }
            return [];
        },
        extractUsersFromLinkData(budgetUsers) {
            const list = [];
            (budgetUsers || []).forEach((ld) => {
                budgetUsers.forEach((u) => {
                    const userId = u.userId;
                    if (userId === undefined || userId === null) return;
                    const name = u.userName || "";
                    list.push({
                        id: userId,
                        name,
                        avatar: String(name || "").slice(0, 1) || "客",
                        viewed: Number(u.status) === 1
                    });
                });
            });
            const map = {};
            list.forEach((u) => {
                const key = String(u.id);
                if (!map[key]) {
                    map[key] = u;
                    return;
                }
                if (u.viewed) map[key].viewed = true;
                if (!map[key].name && u.name) map[key].name = u.name;
                if ((!map[key].avatar || map[key].avatar === "客") && u.avatar) map[key].avatar = u.avatar;
            });

            return Object.values(map);
        },
        extractPriceTextFromLinkData(linkData) {
            const first = (linkData || [])[0];
            const budget = first && Array.isArray(first.details) ? first.details[0] : null;
            const item = budget && Array.isArray(budget.details) ? budget.details[0] : null;
            if (!item) return "￥0";

            const currency = item.currency || "￥";
            if (item.stockPrice || item.stockPrice === 0) return `${currency}${item.stockPrice}`;
            if (typeof item.stockDetail === "string") {
                try {
                    const detail = JSON.parse(item.stockDetail);
                    const priceList = detail && Array.isArray(detail.priceList) ? detail.priceList : [];
                    if (priceList[0] && (priceList[0].price || priceList[0].price === 0)) {
                        return `${priceList[0].currency || currency}${priceList[0].price}`;
                    }
                } catch (e) {
                }
            }
            return `${currency}0`;
        },
        formatTime(value) {
            if (!value && value !== 0) return "";
            const date = new Date(value);
            if (Number.isNaN(date.getTime())) return "";
            const yyyy = date.getFullYear();
            const mm = String(date.getMonth() + 1).padStart(2, "0");
            const dd = String(date.getDate()).padStart(2, "0");
            const hh = String(date.getHours()).padStart(2, "0");
            const mi = String(date.getMinutes()).padStart(2, "0");
            return `${yyyy}-${mm}-${dd} ${hh}:${mi}`;
        },
        showRecordsPage() {
            this.isSlideLeft = false;
        },
        openNewShare() {
            this.selectedRecordId = null;
            this.shareView = "edit";
            this.shareMode = "client";
            this.isSlideLeft = true;
            this.clearSelection();
        },
        openRecord(recordId) {
            this.selectedRecordId = recordId;
            this.shareView = "detail";
            this.isSlideLeft = true;
        },
        openReshare() {
            const record = this.activeRecord;
            if (!record) return;
            this.selectedRecordId = record.id;
            this.shareView = "edit";
            this.shareMode = "client";
            this.isSlideLeft = true;

            const ids = record.users.map((u) => u.id);
            this.selectedIds = ids;
            this.selectedClientMap = {};
            record.users.forEach((u) => {
                this.$set(this.selectedClientMap, u.id, u.name || "");
            });
            this.tableData.forEach((c) => {
                c.selected = this.selectedIds.includes(c.userCid);
            });
        },
        isClientSelected(client) {
            return this.selectedIds.includes(client.userCid);
        },
        toggleClient(client) {
            const id = client.userCid;
            client.selected = !client.selected;
            if (client.selected) {
                if (!this.selectedIds.includes(id)) this.selectedIds.push(id);
                this.$set(this.selectedClientMap, id, client.userCName || client.name || "");
            } else {
                this.selectedIds = this.selectedIds.filter((x) => x !== id);
                this.$delete(this.selectedClientMap, id);
            }
        },
        clearSelection() {
            this.selectedIds = [];
            this.selectedClientMap = {};
            this.searchTerm = "";
            this.tableData.forEach((c) => {
                c.selected = false;
            });
        },
        handleShare() {
            this.shareToSelectedClients();
        },
        shareToSelectedClients() {
            if (this.selectedIds.length === 0) {
                this.$message({type: "warning", message: "请至少选择一位客户"});
                return;
            }

            this.sendLoading = true;
            const names = Object.values(this.selectedClientMap).filter(Boolean).join("、");

            new Api()
                .budgetShare({
                    shareType: 2,
                    userIds: this.selectedIds,
                    budgetDetailIds: this.product && this.product.budgetDetailIds ? this.product.budgetDetailIds : []
                })
                .then((res) => {
                    if (res.status === 200) {
                        const shareId =
                            res.data && (res.data.id || res.data.shareId)
                                ? (res.data.id || res.data.shareId)
                                : typeof res.data === "number"
                                    ? res.data
                                    : null;

                        this.sendLoading = false;
                        this.recordsPage = 1;
                        this.getSharingRecords().then(() => {
                            if (shareId) {
                                this.openRecord(shareId);
                                return;
                            }
                            const first = this.sortedRecords[0];
                            if (first) this.openRecord(first.id);
                        });
                        this.$message({
                            type: "success",
                            message: names ? `商品已成功分享给 ${names}` : "商品已成功分享"
                        });
                    } else {
                        this.sendLoading = false;
                        this.$message({type: "error", message: "分享失败"});
                    }
                })
                .catch(() => {
                    this.sendLoading = false;
                    this.$message({type: "error", message: "分享失败，服务器错误"});
                });
        },
        recordStatusText(record) {
            if (!record) return "";
            const viewedCount = (record.users || []).filter((u) => u.viewed).length;
            const total = (record.users || []).length;
            if (total === 0) return "未查看";
            if (viewedCount === 0) return "未查看";
            if (viewedCount < total) return "部分查看";
            return "全部查看";
        },
        recordStatusClass(record) {
            const text = this.recordStatusText(record);
            if (text === "全部查看") return "viewed";
            if (text === "部分查看") return "partial";
            return "not-viewed";
        },
        recordViewedText(record) {
            if (!record) return "0/0";
            const viewedCount = (record.users || []).filter((u) => u.viewed).length;
            const total = (record.users || []).length;
            return `${viewedCount}/${total}`;
        },
        copyShareLink() {
            const text = this.shareLink || "";
            if (!text) return;
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard
                    .writeText(text)
                    .then(() => {
                        this.$message({type: "success", message: "商品链接已复制到剪贴板"});
                    })
                    .catch(() => {
                        this.$message({type: "warning", message: "复制失败，请手动复制链接"});
                    });
                return;
            }

            const textarea = document.createElement("textarea");
            textarea.value = text;
            textarea.setAttribute("readonly", "readonly");
            textarea.style.position = "fixed";
            textarea.style.left = "-9999px";
            textarea.style.top = "0";
            document.body.appendChild(textarea);
            textarea.select();
            const ok = document.execCommand("copy");
            document.body.removeChild(textarea);
            if (ok) {
                this.$message({type: "success", message: "商品链接已复制到剪贴板"});
            } else {
                this.$message({type: "warning", message: "复制失败，请手动复制链接"});
            }
        },
        generateQRBtn() {
            let obj = {
                jump_wxa: {
                    path: "inquiryPages/exclusiveHotel/exclusiveHotel",
                    query: `url=${encodeURIComponent("inquiryPages/exclusiveHotel/exclusiveHotel")}`,
                    env_version: "develop"
                },
                expire_time: "",
                expire_type: "",
                expire_interval: ""
            };
            new Api("user").systemType(obj).then((res) => {
                if (res.status === 200) {
                    if (typeof res.data === "string") this.qrCodeUrl = res.data;
                }
            });
        },
        handleClientLoadTable(page, size) {
            this.page = page;
            this.pageSize = size;
            this.getCustomerList();
        },
        getCustomerList() {
            const obj = {
                page: this.page,
                q: {},
                size: this.pageSize
            };
            new Api()
                .customizerUserList(obj)
                .then((res) => {
                    if (res.status === 200) {
                        const data = res.data;
                        if (Array.isArray(data)) {
                            this.total = data.length;
                            this.tableData = data.map((x) => this.normalizeClientRow(x));
                        } else {
                            this.total = Number(data && data.total ? data.total : 0);
                            const records = Array.isArray(data && data.records ? data.records : []) ? data.records : [];
                            this.tableData = records.map((x) => this.normalizeClientRow(x));
                        }
                    } else {
                        this.$message({type: "error", message: res.statusText});
                    }
                })
                .catch(() => {
                    this.$message({type: "error", message: "加载失败!"});
                });
        },
        normalizeClientRow(row) {
            return {
                ...row,
                selected: this.selectedIds.includes(row.userCid)
            };
        },
        normalizeImageUrl(url) {
            const str = String(url || "").trim();
            if (!str) return "";
            return str.replace(/^[`'"]+/, "").replace(/[`'"]+$/, "").trim();
        }
    }
};
</script>

<style lang="scss" scoped>
.product-sharing-manage {
    background-color: #f5f7fa;
    color: #333;
    line-height: 1.6;
    height: 100vh;
    overflow: hidden;
}

.container {
    display: flex;
    width: 200%;
    height: 100%;
    transition: transform 0.3s ease;
}

.records-page {
    width: 50%;
    padding: 0 8%;
    height: 100%;
    background-color: white;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.page-header {
    padding: 20px 24px;
    border-bottom: 1px solid #eef1f6;
    background-color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.page-title h1 {
    font-size: 20px;
    font-weight: 600;
    color: #1a1a1a;
    margin-bottom: 4px;
}

.page-title p {
    color: #666;
    font-size: 13px;
}

.new-share-btn {
    background-color: #2575fc;
    color: white;
    border: none;
    border-radius: 8px;
    padding: 8px 16px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 6px;
    transition: all 0.2s;
}

.new-share-btn:hover {
    background-color: #1c68e3;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(37, 117, 252, 0.3);
}

.records-container {
    flex-grow: 1;
    overflow-y: auto;
    padding: 20px 24px;
}

.records-list {
    padding: 0;
}

.records-pagination {
    margin-top: 12px;
}

.records-section-title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 16px;
    color: #1a1a1a;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.record-count {
    font-size: 13px;
    color: #666;
    font-weight: normal;
}

.record-item {
    background-color: white;
    border: 1px solid #eef1f6;
    border-radius: 12px;
    padding: 16px;
    margin-bottom: 12px;
    cursor: pointer;
    transition: all 0.2s;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
}

.record-item:hover {
    border-color: #c2d9ff;
    box-shadow: 0 3px 10px rgba(37, 117, 252, 0.08);
}

.record-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 12px;
}

.record-time {
    font-size: 13px;
    color: #666;
}

.record-status {
    font-size: 11px;
    font-weight: 500;
    padding: 3px 8px;
    border-radius: 12px;
}

.record-status.viewed {
    background-color: #e7f7ef;
    color: #10b759;
}

.record-status.partial {
    background-color: #fef4e6;
    color: #f8a51c;
}

.record-status.not-viewed {
    background-color: #ffeaea;
    color: #ff4757;
}

.record-product {
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 12px;
    color: #1a1a1a;
    display: flex;
    align-items: center;
    gap: 8px;
}

.product-icon {
    width: 24px;
    height: 24px;
    border-radius: 6px;
    background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: bold;
    font-size: 12px;
    flex-shrink: 0;
}

.record-users {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.user-avatars {
    display: flex;
    align-items: center;
}

.user-avatar {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background-color: #e0e6ee;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 600;
    color: #555;
    margin-left: -6px;
    border: 2px solid white;
}

.user-avatar:first-child {
    margin-left: 0;
}

.user-count {
    font-size: 13px;
    color: #666;
    margin-left: 10px;
}

.viewed-count {
    font-size: 13px;
    color: #666;
}

.viewed-count strong {
    color: #10b759;
}

.empty-records {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    text-align: center;
    color: #999;
}

.empty-icon {
    font-size: 48px;
    margin-bottom: 16px;
    color: #e0e6ee;
}

.empty-title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 8px;
    color: #666;
}

.empty-desc {
    font-size: 14px;
    margin-bottom: 20px;
    max-width: 280px;
    line-height: 1.5;
}

.empty-btn {
    background-color: #f0f7ff;
    color: #2575fc;
    border: 1px solid #c2d9ff;
    border-radius: 8px;
    padding: 10px 20px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 6px;
    transition: all 0.2s;
}

.empty-btn:hover {
    background-color: #e1eeff;
}

.share-page {
    width: 50%;
    padding: 0 8%;
    height: 100%;
    background-color: white;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.share-header {
    padding: 20px 24px;
    border-bottom: 1px solid #eef1f6;
    background-color: white;
    display: flex;
    align-items: center;
    gap: 12px;
}

.back-button {
    background: none;
    border: none;
    color: #666;
    font-size: 16px;
    cursor: pointer;
    padding: 6px;
    border-radius: 6px;
    transition: background-color 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
}

.back-button:hover {
    background-color: #f5f7fa;
    color: #2575fc;
}

.share-header h1 {
    font-size: 18px;
    font-weight: 600;
    color: #1a1a1a;
    flex-grow: 1;
}

.share-content {
    flex-grow: 1;
    overflow-y: auto;
    padding: 20px 24px;
}

.share-detail-view {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.share-info-card {
    background-color: white;
    border-radius: 12px;
    padding: 20px;
    border: 1px solid #eef1f6;
    margin-bottom: 16px;
}

.share-meta {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
}

.product-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;
}

.product-image {
    width: 60px;
    height: 60px;
    border-radius: 10px;
    background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: bold;
    font-size: 20px;
    flex-shrink: 0;
}

.product-info h3 {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 4px;
    color: #1a1a1a;
}

.product-price {
    font-size: 20px;
    font-weight: 700;
    color: #ff6b35;
    margin-bottom: 8px;
}

.shared-users-section {
    background-color: white;
    border-radius: 12px;
    padding: 20px;
    border: 1px solid #eef1f6;
    flex-grow: 1;
}

.section-title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 16px;
    color: #1a1a1a;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.shared-user-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 0;
    border-bottom: 1px solid #f5f7fa;
}

.shared-user-item:last-child {
    border-bottom: none;
}

.user-info {
    display: flex;
    align-items: center;
    gap: 10px;
}

.user-avatar-medium {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background-color: #e0e6ee;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 600;
    color: #555;
}

.user-details h4 {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 2px;
    color: #1a1a1a;
}

.user-details p {
    font-size: 12px;
    color: #888;
}

.user-status {
    font-size: 12px;
    font-weight: 500;
    padding: 4px 10px;
    border-radius: 12px;
}

.user-status.viewed {
    background-color: #e7f7ef;
    color: #10b759;
}

.user-status.not-viewed {
    background-color: #ffeaea;
    color: #ff4757;
}

.action-buttons {
    display: flex;
    gap: 12px;
    margin-top: 20px;
}

.action-btn {
    flex: 1;
    padding: 12px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    transition: all 0.2s;
}

.action-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.reshare-btn {
    background-color: #2575fc;
    color: white;
    border: none;
}

.reshare-btn:hover:not(:disabled) {
    background-color: #1c68e3;
}

.copy-btn {
    background-color: white;
    color: #666;
    border: 1px solid #e0e6ee;
}

.copy-btn:hover {
    background-color: #f5f7fa;
    border-color: #c2d9ff;
    color: #2575fc;
}

.share-edit-view {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.share-options {
    display: flex;
    gap: 12px;
    margin-bottom: 20px;
}

.share-option {
    flex: 1;
    border: 1px solid #e0e6ee;
    border-radius: 10px;
    padding: 16px 12px;
    text-align: center;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.share-option:hover {
    border-color: #2575fc;
    background-color: #f8fbff;
}

.share-option.active {
    border-color: #2575fc;
    background-color: #f0f7ff;
}

.option-icon {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    background-color: #2575fc;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
    font-size: 16px;
}

.share-option:nth-child(2) .option-icon {
    background-color: #ff6b35;
}

.option-title {
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 4px;
}

.option-desc {
    font-size: 12px;
    color: #666;
}

.client-selection {
    background-color: white;
    border-radius: 12px;
    padding: 20px;
    border: 1px solid #eef1f6;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
}

.search-box {
    position: relative;
    margin-bottom: 16px;
}

.search-box input {
    width: 100%;
    padding: 12px 12px 12px 40px;
    border: 1px solid #e0e6ee;
    border-radius: 8px;
    font-size: 14px;
    transition: border-color 0.2s;
}

.search-box input:focus {
    outline: none;
    border-color: #2575fc;
}

.search-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #999;
    font-size: 14px;
}

.selected-count {
    font-size: 14px;
    color: #666;
    margin-bottom: 12px;
}

.selected-count strong {
    color: #2575fc;
}

.client-list {
    max-height: 280px;
    overflow-y: auto;
    border: 1px solid #eef1f6;
    border-radius: 8px;
    padding: 8px;
    margin-bottom: 16px;
}

.client-item {
    display: flex;
    align-items: center;
    padding: 10px;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.2s;
    margin-bottom: 6px;
}

.client-item:hover {
    background-color: #f8fafc;
}

.client-item.selected {
    background-color: #f0f7ff;
}

.client-item:last-child {
    margin-bottom: 0;
}

.client-avatar-small {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: #e0e6ee;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    font-size: 13px;
    font-weight: 600;
    color: #555;
    flex-shrink: 0;
    overflow: hidden;
}

.avatar-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.avatar-text {
    font-size: 13px;
    font-weight: 600;
}

.client-details {
    flex-grow: 1;
}

.client-name {
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 2px;
}

.client-contact {
    font-size: 12px;
    color: #888;
}

.selection-indicator {
    color: #2575fc;
    font-size: 16px;
}

.share-action-btn {
    width: 100%;
    padding: 14px;
    background-color: #2575fc;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s;
}

.share-action-btn:hover {
    background-color: #1c68e3;
}

.share-action-btn:disabled {
    background-color: #ccc;
    cursor: not-allowed;
}

.qr-container {
    background-color: white;
    border-radius: 12px;
    padding: 30px 20px;
    border: 1px solid #eef1f6;
    text-align: center;
    flex-grow: 1;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
}

.qr-code {
    width: 180px;
    height: 180px;
    background-color: #f5f7fa;
    border-radius: 12px;
    margin: 0 auto 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999;
    font-weight: 600;
    overflow: hidden;
}

.qr-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
}

.qr-desc {
    color: #666;
    font-size: 14px;
    max-width: 280px;
    margin: 0 auto 20px;
}

.slide-left {
    transform: translateX(-50%);
}

.pagination-wrap {
    margin-top: auto;
    margin-bottom: 16px;
}

@media (max-width: 768px) {
    .container {
        width: 200%;
    }

    .records-page,
    .share-page {
        width: 100%;
    }

    .share-options {
        flex-direction: column;
    }

    .page-header,
    .share-header {
        padding: 16px 20px;
    }

    .share-content,
    .records-container {
        padding: 16px 20px;
    }

    .action-buttons {
        flex-direction: column;
    }
}
</style>
